import { getUnidade } from "../funcs"

export const apiLink = () => process.env.REACT_APP_API_LINK + `${getUnidade().unidadeId}/`
export const apiAuthLink = process.env.REACT_APP_AUTH_API_LINK